import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryPenalties.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';


const AvailMainSideSummaryPenalties = class AvailMainSideSummaryPenalties extends React.Component {
  static displayName = 'AvailMainSideSummaryPenalties';

  render() {
    const { config, theme } = this.props,
      {
        penalties,
        pms,
        discountPercent,
        text,
        stepCode,
      } = config;
    
    const { classes } = theme.styles;
    
    let prevPenaltyNR = false;


    return (
      <div className={[classes.penaltiesContainer, stepCode === 'confirmation' ? classes.resizePenaltiesContainer : ''].join(' ')}>
        <div className={classes.penaltiesContent}>
          {penalties && penalties.map((penalty, key) => {
            if (penalty.nr === true) {
              prevPenaltyNR = true;
            }
            let rateName = '';
  
            if (penalty.nr !== true && !penalty.applyPenaltyRelease) {
              rateName = '_%cancelación gratuita%_';
            } else if (penalty.nr === true && pms === 'FlexMyRoom') {
              rateName = '_%cancelación segura%_';
            } else if (penalty.nr === true && discountPercent <= -5) {
              rateName = '_%tarifa de oferta%_';
            } else {
              rateName = '_%condiciones especiales%_';
            }
            return (
              (key === 0 || !prevPenaltyNR) && (
                <div className={classes.penaltiesBlock} key={key}>
                  <RichText
                    text={rateName}
                    ucFirst={true}
                    translate={true}
                    innerStyle={[classes.penaltiesTitle, 'roboto11Black400', 'mainColor']}
                  />
                  <RichText
                    translate={true}
                    text={penalty.text}
                    withVars={penalty}
                    ucFirst={true}
                    innerStyle={[classes.penaltiesText, 'roboto11Black400']}
                    dangerouslySetInnerHTML={true}
                  />
                </div>
              )
            );
          })}
          {text && text.length > 0 && <div>
            <RichText
              text={text}
              innerStyle={classes.penaltiesText}
            />
          </div>}
        </div>
      </div>
    )
  }
};

export default compose(
  PropertyManager([
    'penalties',
    'pms',
    'discountPercent',
    'text',
    'stepCode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryPenalties);
